// noinspection JSUnresolvedReference

/*
 * managers: This file contains API requests pertaining to a user's manager(s).
 *
 * If the user is found, it will return the user's information.
 * If the user isn't found or an error occurs, it will return an error message.
 */
import makeRequest from "../api/apiRequest";
import { constructUrl } from "./apiConfig";
import { ManagerInfo, ManagerInfoSchema } from "../types/manager";
import { validateApiResponse } from "../types/validators";

/**
 * getManagers: This function will search a user's manager(s) by email address and returns the object.
 * @param   {string} email   User's email address
 * @returns {Promise<{managerInfo, errorMsg: null}|{managerInfo: null, errorMsg}>}
 */
export const getManagers = async (email: string): Promise<{
  managerInfo: ManagerInfo | null;
  errorMsg: string | null;
}> => {
  const url = constructUrl("/managers");
  const response = await makeRequest(url, "GET", null, { user: email }, {});

  if (response.errorType === 0) {
    // Request success and data exists
    try {
      const managerInfo = validateApiResponse(
        ManagerInfoSchema,
        { errorType: 0, data: response.data },
        'getManagers'
      );
      return {
        managerInfo,
        errorMsg: null,
      };
    } catch {
      return {
        managerInfo: null,
        errorMsg: "Manager response failed validation",
      };
    }
  } else {
    return {
      managerInfo: null,
      errorMsg: response.errorMessage,
    };
  }
};
